import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

export type ShipMode = "air" | "sea" | "road";

export type ModeOption = { mode: ShipMode; daysMin: number; daysMax: number };

export const MODE_LABEL: Record<string, string> = { air: "Air", sea: "Sea", road: "Road" };

const MODE_ORDER: ShipMode[] = ["air", "sea", "road"];

export function modeLabel(mode?: string | null): string {
  return MODE_LABEL[mode ?? ""] ?? (mode ?? "");
}

function isShipMode(mode: unknown): mode is ShipMode {
  return mode === "air" || mode === "sea" || mode === "road";
}

export function useQuoteRoutes() {
  return useQuery({
    queryKey: ["quote", "routes"],
    queryFn: () => api.quoteRoutes(),
    staleTime: 10 * 60 * 1000,
  });
}

export function useModeOptions(origin: string): ModeOption[] {
  const { data } = useQuoteRoutes();
  if (!origin) return [];
  const options = (data ?? [])
    .filter((r) => r.originCountry === origin && isShipMode(r.mode))
    .map((r) => ({ mode: r.mode as ShipMode, daysMin: r.daysMin ?? 0, daysMax: r.daysMax ?? 0 }));
  return MODE_ORDER.flatMap((mode) => options.find((o) => o.mode === mode) ?? []);
}

export function transitDays(option: ModeOption): string {
  if (!option.daysMax) return "";
  return option.daysMin && option.daysMin !== option.daysMax
    ? `${option.daysMin} to ${option.daysMax} days`
    : `${option.daysMax} days`;
}
